// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6zpE1 {\n  width: 100%;\n  height: 2px;\n  background-color: var(--color-gray-light);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "_6zpE1"
};
export default ___CSS_LOADER_EXPORT___;
